import { server_ip } from "../config";

export async function fetchPushNotifications( token, filter, options) {
    try {
        const response = await fetch(`${server_ip}/api/pushNotifications/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                options,
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function deletePushNotificationById(token, id) {
    try {
        const response = await fetch(`${server_ip}/api/pushNotifications/${id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}
export async function sendPushNotification(token, filter, data, body) {
    try {
        const response = await fetch(`${server_ip}/api/pushNotifications/send`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                filter,
                data,
                body,
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}